var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyBox = function SvgEmptyBox(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3552 121.985C24.3552 134.592 26.8383 147.075 31.6628 158.722C36.4872 170.37 43.5585 180.953 52.4729 189.867C61.3874 198.782 71.9703 205.853 83.6176 210.677C95.2648 215.502 107.748 217.985 120.355 217.985C132.962 217.985 145.446 215.502 157.093 210.677C168.74 205.853 179.323 198.782 188.237 189.867C197.152 180.953 204.223 170.37 209.048 158.722C213.872 147.075 216.355 134.592 216.355 121.985C216.355 96.5241 206.241 72.1061 188.237 54.1026C170.234 36.0991 145.816 25.9849 120.355 25.9849C94.8944 25.9849 70.4764 36.0991 52.4729 54.1026C34.4695 72.1061 24.3552 96.5241 24.3552 121.985Z",
    fill: "#D8ECF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4896 194.506C69.6415 205.053 84.2513 212.373 99.9742 215.794C115.697 219.215 132.028 218.625 147.463 214.08V170.246H57.4896V194.506Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.463 214.078V170.246H57.4896V194.506",
    stroke: "#002B4C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.463 214.08C160.493 210.243 172.558 203.678 182.856 194.82V134.854L147.463 170.246V214.08Z",
    fill: "#A0CEE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182.856 194.82V134.854L147.463 170.246V214.078",
    stroke: "#002B4C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4896 170.246L92.8848 134.851H182.856L147.463 170.246H57.4896Z",
    fill: "#A0CEE9",
    stroke: "#002B4C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0072 134.851H92.8848L57.4896 170.246H93.0072V134.851Z",
    fill: "#A0CEE9",
    stroke: "#002B4C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.88 134.851L54.6696 143.102C54.2151 143.198 53.7982 143.424 53.4696 143.753L24.348 172.884C23.9823 173.251 23.7449 173.726 23.6713 174.238C23.5977 174.751 23.6919 175.273 23.9397 175.728C24.1875 176.183 24.5758 176.545 25.0464 176.761C25.5171 176.977 26.0449 177.034 26.5512 176.926L57.4896 170.246L92.88 134.851Z",
    fill: "white",
    stroke: "#002B4C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M215.606 151.807C215.886 151.527 216.093 151.183 216.207 150.804C216.321 150.425 216.34 150.024 216.262 149.636C216.184 149.248 216.011 148.885 215.759 148.58C215.507 148.275 215.183 148.038 214.817 147.888L182.856 134.851L147.463 170.246L181.303 184.044C181.741 184.222 182.221 184.268 182.685 184.174C183.148 184.081 183.573 183.853 183.907 183.518L215.606 151.807Z",
    fill: "white",
    stroke: "#002B4C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyBox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "214c670b51d76a406ec421889e80d1b2.svg";